import Vue from 'vue';
import VueRouter from 'vue-router';
import Landing from '../views/Landing.vue';
import Home from '../views/Home.vue';
import Mechanism from '../views/Mechanism.vue';
// import StyleGuide from '../views/StyleGuide.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'landing',
    component: Landing,
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
  },
  {
    path: '/mechanism',
    name: 'mechanism',
    component: Mechanism,
  },
  //
  // {
  //   path: '/style-guide',
  //   name: 'style-guide',
  //   component: StyleGuide,
  // },
];

const router = new VueRouter({
  routes
});

export default router;
